<template>
  <v-container class="mt-3">
    <v-card>
      <v-card-title
        ><h1 class="text-h6 font-weight-bold ma-0">
          Tech Startup Resume Guide: How to Stand Out Without a Big-Name
          Employer
        </h1></v-card-title
      >
      <v-card-text>
        <resume-cta-banner />
        <v-row>
          <v-col cols="12">
            Startups screen resumes differently than large tech companies.
            There's usually no ATS keyword filter and no hiring committee —
            often a founder, engineering lead, or small team reads your resume
            directly. What they're looking for is different too: less about
            scale and process, more about ownership, versatility, and whether
            you can operate with limited resources and ambiguity.
          </v-col>
        </v-row>

        <h2 class="text-h6 mt-4 mb-2">
          1. Show What You Built, Not Just Where You Worked
        </h2>
        <p>
          Brand-name experience matters less at a startup than concrete proof
          you can ship. If you have side projects, an open-source contribution,
          a personal app, or a 0-to-1 build at a previous job, lead with it —
          link to a GitHub repo, live demo, or portfolio whenever possible.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          2. Emphasize Range Over Specialization
        </h2>
        <p>
          Early-stage teams need people who can wear multiple hats. Instead of
          only listing deep expertise in one narrow area, highlight the breadth
          of what you've done — front end and back end, product and engineering,
          or technical and customer-facing work.
        </p>
        <ul>
          <li>
            <strong>Narrow:</strong> "Built React components for the checkout
            page."
          </li>
          <li>
            <strong>Broad:</strong> "Built the checkout flow end-to-end — React
            front end, Node.js API, and Stripe integration — as the sole
            engineer on the project."
          </li>
        </ul>

        <h2 class="text-h6 mt-4 mb-2">
          3. Highlight Comfort With Ambiguity and Speed
        </h2>
        <p>
          Startups rarely hand you a fully-scoped spec. Show that you can take a
          vague problem and move it forward: "Defined and shipped a referral
          program from scratch in 3 weeks with no existing infrastructure,
          driving 15% of new signups within a month."
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          4. Tie Your Impact to Business Metrics
        </h2>
        <p>
          At a startup, engineering and business impact are closely linked.
          Where you can, connect your work to revenue, retention, growth, or
          runway — metrics a founder cares about directly, not just engineering
          metrics in isolation.
        </p>

        <h2 class="text-h6 mt-4 mb-2">5. Keep It Short and Direct</h2>
        <p>
          Founders and small teams read resumes quickly and informally. One
          page, clear bullets, and a short summary of what you're looking for
          next tend to work better than a dense, formal document.
        </p>

        <h2 class="text-h6 mt-4 mb-2">6. Explain Why This Startup, Briefly</h2>
        <p>
          Unlike large companies, startups often want to see genuine interest in
          their specific product or mission. A single line in your summary
          connecting your background to what the company does can go a long way.
        </p>

        <v-alert type="info" outlined class="mt-4">
          Tip: If you're weighing a startup against larger companies, see our
          <router-link to="/faang-resume-guide">FAANG resume guide</router-link>
          or
          <router-link to="/amazon-resume-guide"
            >Amazon resume guide</router-link
          >
          for how the emphasis shifts at bigger, more process-driven employers.
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ResumeCtaBanner from "../../components/ResumeCtaBanner.vue";

export default {
  name: "TechStartupResumeGuide",
  components: { ResumeCtaBanner },
  mounted() {
    this.$utils.visit(this);
  },
};
</script>
